import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { SavedFilter } from '../../core/models/saved-filter.model';

/**
 * Barra de chips de "filtros salvos" (nome + cor + ícone), reutilizável por qualquer
 * listagem — não conhece o formato dos parâmetros do filtro (`SavedFilter<unknown>`),
 * só exibe/aplica/desativa/exclui pelo id/name/color/icon.
 *
 * Clique no chip inativo aplica o filtro; clique no chip já ativo desativa
 * (a página decide o que "desativar" significa — normalmente restaurar os filtros
 * anteriores). A confirmação antes de excluir fica a cargo da página consumidora.
 */
@Component({
  selector: 'app-saved-filter-chips',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './saved-filter-chips.component.html',
  styleUrls: ['./saved-filter-chips.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SavedFilterChipsComponent {
  readonly enableSavedFilters = input(false);
  readonly savedFilters = input<SavedFilter<unknown>[]>([]);
  /** Id do filtro salvo atualmente ativo (fica com a cor vibrante). */
  readonly activeSavedFilterId = input<string | null>(null);

  readonly applyFilter = output<SavedFilter<unknown>>();
  readonly deactivateFilter = output<void>();
  readonly deleteFilter = output<SavedFilter<unknown>>();

  isSavedFilterActive(filter: SavedFilter<unknown>): boolean {
    return !!filter.id && filter.id === this.activeSavedFilterId();
  }

  onSavedFilterClick(filter: SavedFilter<unknown>): void {
    if (this.isSavedFilterActive(filter)) {
      this.deactivateFilter.emit();
    } else {
      this.applyFilter.emit(filter);
    }
  }

  onDeleteFilter(event: Event, filter: SavedFilter<unknown>): void {
    event.stopPropagation();
    this.deleteFilter.emit(filter);
  }
}
